import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request, sleep } from "@/js/http/http_request";
import { getErrorData } from "@/js/forms.js";
import { orderTypes } from "@/js/lists.ts";
import MailTemplateForm from "@/components/mail/MailTemplateForm.vue";
import MailTemplateModal from "@/components/mail/MailTemplateModal.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  props: {
    order: Object,
    inboundDelivery: Object,
    user: Object,
    purchaseOrder: Object
  },
  data: function data() {
    return {
      shown: false,
      options: {
        color: "primary",
        width: 600,
        zIndex: 2000
      },
      emailTemplates: [],
      emailPlaceholders: null,
      documents: [],
      isDeletingTemplate: false,
      form: {
        emailTemplate: {
          id: 0,
          sendTo: [],
          files: [],
          mailHistories: []
        }
      },
      savedSendToMails: [],
      isSending: false,
      templateModalShown: false,
      editableTemplate: {},
      isSyncing: false,
      isNeedingSync: false,
      isMailTemplateFormLoading: false,
      managedExceptions: {
        warning: {
          email_from_not_authorized: "The email from address that does not belong to you or that is not configured is not authorized."
        }
      }
    };
  },
  components: {
    MailTemplateForm: MailTemplateForm,
    MailTemplateModal: MailTemplateModal,
    Confirm: Confirm
  },
  created: function created() {
    if (this.order) {
      this.form.emailTemplate.sendTo.push(this.order.user.login);
      if (this.order.user.hasComplementaryContactEmail) this.form.emailTemplate.sendTo.push(this.order.user.contactEmail);
      if (this.order.user.hasSpecificBillingEmail) this.form.emailTemplate.sendTo.push(this.order.user.billingEmail);
      if (!this.isOrderServiceInvoice) {
        this.fetchOrderDocuments();
        this.fetchEmailPlaceholders("orderId=".concat(this.order.id_order));
      } else {
        this.fetchStandaloneOrderDocuments();
        this.fetchEmailPlaceholders("standaloneOrderId=".concat(this.order.id_order));
      }
    } else if (this.inboundDelivery) {
      this.form.emailTemplate.sendTo.push(this.inboundDelivery.user.login);
      if (this.inboundDelivery.user.hasComplementaryContactEmail) this.form.emailTemplate.sendTo.push(this.inboundDelivery.user.contactEmail);
      if (this.inboundDelivery.user.hasSpecificBillingEmail) this.form.emailTemplate.sendTo.push(this.inboundDelivery.user.billingEmail);
      this.fetchInboundDeliveryDocuments();
      this.fetchEmailPlaceholders("inboundDeliveryId=".concat(this.inboundDelivery.id));
    } else if (this.user) {
      this.form.emailTemplate.sendTo.push(this.user.login);
      if (this.user.hasComplementaryContactEmail) this.form.emailTemplate.sendTo.push(this.user.contactEmail);
      if (this.user.hasSpecificBillingEmail) this.form.emailTemplate.sendTo.push(this.user.billingEmail);
      this.fetchEmailPlaceholders("userId=".concat(this.user.id_user));
    } else if (this.purchaseOrder) {
      if (this.purchaseOrder.supplierEmail != null && this.purchaseOrder.supplierEmail !== "") {
        this.form.emailTemplate.sendTo.push(this.purchaseOrder.supplierEmail);
      }
      this.fetchEmailPlaceholders("purchaseOrderId=".concat(this.purchaseOrder.id));
    }
    this.saveSendToMails();
    this.fetchEmailTemplates();
  },
  computed: {
    isInvalidForm: function isInvalidForm() {
      var nullishPredicate = function nullishPredicate(x) {
        var _x$sendTo, _x$htmlContent;
        return !x.from || !((_x$sendTo = x.sendTo) !== null && _x$sendTo !== void 0 && _x$sendTo.length) || !x.subject || !((_x$htmlContent = x.htmlContent) !== null && _x$htmlContent !== void 0 && _x$htmlContent.replace(/<[^>]*>?/gm, ""));
      };
      if (nullishPredicate(this.form.emailTemplate)) return true;
      if (this.isMailTemplateFormLoading) return true;
      return false;
    },
    flattenPlaceholders: function flattenPlaceholders() {
      return Object.values(this.emailPlaceholders || {}).flat();
    },
    isOrderServiceInvoice: function isOrderServiceInvoice() {
      var _this$order;
      return ((_this$order = this.order) === null || _this$order === void 0 ? void 0 : _this$order.type) == orderTypes.STANDALONE;
    }
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    closeTemplateModal: function closeTemplateModal() {
      var _this2 = this;
      this.editableTemplate = {};
      this.$nextTick(function () {
        return _this2.templateModalShown = false;
      });
    },
    fetchEmailPlaceholders: function fetchEmailPlaceholders(query) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response, sortedPlaceholders;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return request("/v1/mail/placeholders?".concat(query), "get", null, true, "api");
            case 2:
              response = _context.sent;
              if (response !== null && response !== void 0 && response.data) {
                _context.next = 6;
                break;
              }
              _this3.emailPlaceholders = {};
              return _context.abrupt("return");
            case 6:
              sortedPlaceholders = Object.entries(response.data).sort(function (a, b) {
                var _b$, _a$;
                return (((_b$ = b[1]) === null || _b$ === void 0 ? void 0 : _b$.length) || 0) - (((_a$ = a[1]) === null || _a$ === void 0 ? void 0 : _a$.length) || 0);
              }).reduce(function (acc, _ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];
                acc[key] = value;
                return acc;
              }, {});
              _this3.emailPlaceholders = sortedPlaceholders;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchEmailTemplates: function fetchEmailTemplates() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this4;
              _context2.next = 3;
              return request("/v1/mail/templates", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to fetch email templates.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context2.sent;
              _this4.emailTemplates = _toConsumableArray(response.data).map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  files: [],
                  sendTo: []
                });
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchOrderDocuments: function fetchOrderDocuments() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.isLoadingFiles = true;
              _this = _this5;
              _context3.next = 4;
              return request("/v1/orders/" + _this5.order.id_order + "/docs", "get", null, true, "api").catch(function (e) {
                _this.isLoadingFiles = false;
                throw e;
              });
            case 4:
              response = _context3.sent;
              _this5.documents = response.data.reduce(function (acc, x) {
                return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
                  children: _toConsumableArray(x.document_urls)
                })]);
              }, []);
              _this5.isLoadingFiles = false;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchStandaloneOrderDocuments: function fetchStandaloneOrderDocuments() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.isLoadingFiles = true;
              _this = _this6;
              _context4.next = 4;
              return request("/v1/standalone-orders/" + _this6.order.id_order + "/invoice", "get", null, true, "api").catch(function (e) {
                _this.isLoadingFiles = false;
                throw e;
              });
            case 4:
              response = _context4.sent;
              _this6.documents = [{
                id: 0,
                children: [{
                  name: response.data.value.filename,
                  url: response.data.value.url
                }],
                document_urls: [{
                  name: response.data.value.filename,
                  url: response.data.value.url
                }],
                name: "Invoice"
              }];
              _this6.isLoadingFiles = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchInboundDeliveryDocuments: function fetchInboundDeliveryDocuments() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.isLoadingFiles = true;
              _this = _this7;
              _context5.next = 4;
              return request("/v1/inbound/delivery/".concat(_this7.inboundDelivery.id, "/docs"), "get", null, true, "api", null).then(function (response) {
                _this.documents = response.data.value.reduce(function (acc, x) {
                  return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
                    children: _toConsumableArray(x.document_urls)
                  })]);
                }, []);
                _this.isLoadingFiles = false;
              }).catch(function (e) {
                _this.isLoadingFiles = false;
                throw e;
              });
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    saveTemplate: function saveTemplate(template, success, fail) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this8;
              _context6.next = 3;
              return request("/v1/mail/templates", !!template.id ? "put" : "post", template, true, "api").catch(function (e) {
                var _e$response$data, _e$response$data2;
                var errorCode = (_e$response$data = e.response.data) === null || _e$response$data === void 0 || (_e$response$data = _e$response$data.value) === null || _e$response$data === void 0 ? void 0 : _e$response$data.errorCode;
                if (errorCode) {
                  var errorData = getErrorData(e, _this.managedExceptions);
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                } else if ((_e$response$data2 = e.response.data) !== null && _e$response$data2 !== void 0 && _e$response$data2.value) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "error"
                  });
                } else {
                  _this.$toasted.show("Unable to save the new template.", {
                    type: "error"
                  });
                }
                fail();
                throw e;
              });
            case 3:
              _this8.$toasted.show("Template saved.", {
                type: "success"
              });
              if (!!template.id) _this8.isNeedingSync = true;else _this8.fetchEmailTemplates();
              success();
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    editTemplate: function editTemplate(id) {
      this.templateModalShown = true;
      var template = this.emailTemplates.find(function (x) {
        return x.id === id;
      });
      this.editableTemplate = _objectSpread({}, template);
    },
    deleteTemplate: function deleteTemplate(templateId) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var isConfirmed, _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this9.$refs.confirm.open("Confirm", "Are you sure you want to remove it permanently?");
            case 2:
              isConfirmed = _context7.sent;
              if (!isConfirmed) {
                _context7.next = 13;
                break;
              }
              _this9.isDeletingTemplate = true;
              _this = _this9;
              _context7.next = 8;
              return request("/v1/mail/templates/".concat(templateId), "delete", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to delete this template.", {
                  type: "error"
                });
                _this.isDeletingTemplate = false;
                throw e;
              });
            case 8:
              _context7.next = 10;
              return _this9.fetchEmailTemplates();
            case 10:
              if (_this9.form.emailTemplate.id == templateId) {
                _this9.form.emailTemplate.id = 0;
              }
              _this9.editableTemplate = {};
              _this9.isDeletingTemplate = false;
            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    newTemplate: function newTemplate() {
      var _this10 = this;
      this.$nextTick(function () {
        return _this10.templateModalShown = true;
      });
    },
    changeTemplate: function changeTemplate(item) {
      var reduce = function reduce(acc, x) {
        return acc.replaceAll(x.symbol, x.filledValue);
      };
      this.form.emailTemplate = _objectSpread(_objectSpread({}, item), {}, {
        subject: this.flattenPlaceholders.reduce(reduce, item.subject),
        htmlContent: this.flattenPlaceholders.reduce(reduce, item.htmlContent),
        sendTo: this.savedSendToMails
      });
    },
    clickPlaceholder: function clickPlaceholder(item, callback) {
      callback(this.replaceSymbol(item.symbol));
    },
    replaceSymbol: function replaceSymbol(value) {
      var _this$flattenPlacehol;
      return ((_this$flattenPlacehol = this.flattenPlaceholders.find(function (x) {
        return x.symbol === value;
      })) === null || _this$flattenPlacehol === void 0 ? void 0 : _this$flattenPlacehol.filledValue) || "";
    },
    saveSendToMails: function saveSendToMails() {
      this.savedSendToMails = this.form.emailTemplate.sendTo;
    },
    sendMail: function sendMail() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var template, formData, _this;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this11.isSending = true;
              template = _this11.form.emailTemplate;
              if (template.id !== 0) template.templateId = template.id;
              formData = new FormData();
              Object.keys(template).forEach(function (key) {
                return formData.append(key, template[key]);
              });
              template.files.forEach(function (x) {
                formData.append("files", !x.blob ? x : new File([x.blob], x.id));
              });
              _this = _this11;
              _context8.next = 9;
              return request("/v1/mail/send", "post", formData, true, "api").then(function () {
                _this.$toasted.show("Mail successfully sent.", {
                  type: "success"
                });
              }).catch(function (e) {
                var _e$response;
                if ((_e$response = e.response) !== null && _e$response !== void 0 && (_e$response = _e$response.data) !== null && _e$response !== void 0 && _e$response.value) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "warning"
                  });
                } else {
                  _this.$toasted.show("Something went wrong.", {
                    type: "error"
                  });
                }
                _this11.isSending = false;
                throw e;
              });
            case 9:
              _this11.isSending = false;
              _this11.close();
            case 11:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    syncLatestVersion: function syncLatestVersion() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this12.isSyncing = true;
              _context9.next = 3;
              return _this12.fetchEmailTemplates();
            case 3:
              if (!!_this12.form.emailTemplate.id) {
                _this12.changeTemplate(_this12.form.emailTemplate);
              }
              _this12.isSyncing = false;
              _this12.isNeedingSync = false;
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    changeLoadingState: function changeLoadingState(isLoading) {
      this.isMailTemplateFormLoading = isLoading;
    }
  }
};